<script>
    import { Router, Link } from "svelte-navigator";
    import { onMount } from "svelte";
    import baseUrl from "../config/config";

    let topProducts = [];

    const getTopProducts = () => {
        fetch(baseUrl + "get-top-products.php")
            .then((res) => res.json())
            .then((data) => {
                topProducts = data;
                console.log(data);
            })
            .catch((e) => {
                console.log(e);
            });
    };

    onMount(() => {
        getTopProducts();
    });
</script>

<main>
    <div class="mainContainer ui grid">
        <div class="sixteen wide column" />
        <div class="titleCol sixteen wide column">
            <div class="ui grid">
                <div class="eleven wide column">
                    <div class="title">TOP PRODUCTS</div>
                </div>
                <div class="five wide column">
                    <Link to="/store/top-products">
                        <div class="link">
                            <i class="eye icon" /> View All
                        </div>
                    </Link>
                </div>
            </div>
        </div>

        <div class="contentCol sixteen wide column">
            <div class="ui grid">
                <div class="doubling five column row">
                    {#each topProducts as product}
                        <div class="column">
                            <Link to={"/store/product/" + product.slug}>
                                <div class="productContainer">
                                    <div class="productImage">
                                        <img
                                            src={baseUrl + product.image}
                                            alt="product"
                                        />
                                    </div>

                                    <div class="productName">
                                        {product.name}
                                    </div>

                                    <div class="">
                                        <div class="ui grid">
                                            <div class="eight wide column">
                                                <div class="size">
                                                    {product.size}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="prices">
                                        {#if product.salePrice == 0}
                                            <!-- just regulal price -->
                                            <span class="regularPrice">
                                                Ksh. {product.regularPrice}
                                            </span>
                                        {:else}
                                            <!-- both regula and the sale price -->

                                            <span class="nowPrice">
                                                Ksh. {product.salePrice}
                                            </span>
                                            &nbsp;&nbsp;

                                            <span class="wasPrice">
                                                Ksh. {product.regularPrice}
                                            </span>
                                        {/if}
                                    </div>

                                    <div class="ratings">
                                        <div class="ui grid">
                                            <div class="re ten wide column">
                                                <div
                                                    class="ui mini star rating"
                                                    data-rating="5"
                                                    data-max-rating="5"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    {/each}
                </div>
            </div>
        </div>
    </div>
</main>

<style>
    main {
        text-align: left;
        padding-top: 1em;
    }

    .title {
        letter-spacing: 2px;
        line-height: 25px;
        font-size: 15px;
    }

    .link {
        text-align: right;
        color: brown;
        font-size: 13px;
        font-weight: 600;
    }

    .titleCol {
        border-bottom: 1px solid rgba(182, 180, 180, 0.422);
    }

    .productImage {
        margin: 1em !important;
        /* background: orange; */
        padding: 1em;
        min-height: 22em;
        border-bottom: 1px solid rgba(43, 42, 42, 0.288);
    }

    .productImage img {
        max-width: 100%;
        height: auto;
    }

    .productContainer {
        border-radius: 3px;
        cursor: pointer;
        /* background: red; */
        margin-top: 3em;
    }

    .productContainer:hover {
        -webkit-box-shadow: 0px 1px 2px 2px #dddddd;
        box-shadow: 0px 1px 2px 2px #dddddd;
    }

    .size {
        padding-left: 1.1em;
        color: rgb(104, 103, 103);
    }

    .productName {
        font-weight: 500;
        padding-inline: 1em;
        font-size: 13px;
        min-height: 4em;
        color: black;
    }

    .prices {
        padding-top: 1em;
        /* padding-left: 10px; */
    }

    .regularPrice {
        color: brown;
        font-weight: 500;
        font-size: 13px;
        padding: 1em;
    }

    .nowPrice {
        font-size: 14px;
        font-weight: 400;
        padding-left: 1em;
        color: black;
    }

    .wasPrice {
        text-decoration: line-through;
        color: gray;
        font-size: 13px;
    }
</style>
